import { inject, ref, type InjectionKey, type Ref } from "vue"

export interface EmbedModeContext {
  /** Whether the app is running in embedded mode */
  isEmbedded: Ref<boolean>
  /** The parent window's origin (for security validation) */
  parentOrigin: Ref<string | null>
  /** Whether embed mode has been initialized */
  isInitialized: Ref<boolean>
}

export const EMBED_MODE_KEY: InjectionKey<EmbedModeContext> = Symbol("embedMode")

/**
 * Inject embed mode context.
 * Use this in components to check if running in embedded mode.
 */
export function useEmbedMode(): EmbedModeContext {
  const context = inject(EMBED_MODE_KEY)

  if (!context) {
    // Return safe defaults if not in embed context
    return {
      isEmbedded: ref(false),
      parentOrigin: ref(null),
      isInitialized: ref(false)
    }
  }

  return context
}
